import React from "react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/mock";
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer id="about" className="bg-[#08080a] border-t border-[#1c1c1e]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-serif italic text-[#c9a24a] text-2xl">Jhumar</span>
              <span className="text-[#e9d9b0] text-xs tracking-[0.35em] uppercase">
                Collection
              </span>
            </div>
            <p className="text-[#a9a294] text-sm mt-5 leading-relaxed max-w-xs">
              Handpicked chandeliers, pendants and wall lights. Crafted honestly,
              priced clearly, delivered across India.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 border border-[#2a2724] flex items-center justify-center text-[#e9d9b0] hover:text-[#c9a24a] hover:border-[#c9a24a] transition-colors"
              >
                <Instagram size={15} />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 border border-[#2a2724] flex items-center justify-center text-[#e9d9b0] hover:text-[#c9a24a] hover:border-[#c9a24a] transition-colors"
              >
                <Facebook size={15} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.3em] mb-5">
              Shop
            </div>
            <ul className="space-y-3 text-[#e9d9b0] text-sm">
              <li><a href="#chandeliers" className="hover:text-[#c9a24a] transition-colors">Chandeliers</a></li>
              <li><a href="#pendants" className="hover:text-[#c9a24a] transition-colors">Pendants</a></li>
              <li><a href="#wall-lights" className="hover:text-[#c9a24a] transition-colors">Wall Lights</a></li>
              <li><a href="#ceiling" className="hover:text-[#c9a24a] transition-colors">Ceiling</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.3em] mb-5">
              Help
            </div>
            <ul className="space-y-3 text-[#e9d9b0] text-sm">
              <li><Link to="/shipping" className="hover:text-[#c9a24a] transition-colors">Shipping & Delivery</Link></li>
              <li><Link to="/returns" className="hover:text-[#c9a24a] transition-colors">Returns & Refunds</Link></li>
              <li><Link to="/installation" className="hover:text-[#c9a24a] transition-colors">Installation Guide</Link></li>
              <li><Link to="/warranty" className="hover:text-[#c9a24a] transition-colors">Warranty</Link></li>
              <li><Link to="/contact" className="hover:text-[#c9a24a] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.3em] mb-5">
              Visit our showroom
            </div>
            <div className="space-y-4 text-[#e9d9b0] text-sm">
              <div className="flex gap-3">
                <MapPin size={16} className="text-[#c9a24a] mt-0.5 flex-shrink-0" />
                <div className="leading-relaxed">
                  <div>{BUSINESS.address.line1}</div>
                  <div>{BUSINESS.address.line2}</div>
                  <div>{BUSINESS.address.line3}</div>
                  <div>
                    {BUSINESS.address.city} – {BUSINESS.address.pin}, {BUSINESS.address.state}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={15} className="text-[#c9a24a]" />
                <a href={`tel:${BUSINESS.phone}`} className="hover:text-[#c9a24a] transition-colors">
                  {BUSINESS.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={15} className="text-[#c9a24a]" />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-[#c9a24a] transition-colors">
                  {BUSINESS.email}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Clock size={15} className="text-[#c9a24a]" />
                <span>{BUSINESS.hours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1c1c1e] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[#a9a294] text-xs">
            © {new Date().getFullYear()} {BUSINESS.legalName}. All rights reserved.
          </div>
          <div className="text-[#a9a294] text-xs tracking-wide">
            GSTIN: {BUSINESS.gstin}
          </div>
          <div className="flex gap-6 text-[#a9a294] text-xs">
            <Link to="/privacy" className="hover:text-[#c9a24a] transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-[#c9a24a] transition-colors">Terms</Link>
            <Link to="/refunds" className="hover:text-[#c9a24a] transition-colors">Refunds</Link>
            <Link to="/cancellation" className="hover:text-[#c9a24a] transition-colors">Cancellation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
